<template>
  <div>
    <h1>Manage Attachments</h1>
    <div>
      <b-card no-body>
        <b-tabs pills card vertical nav-wrapper-class="w-25">
          <b-tab title="Attachment Type Settings" active v-if="isAdmin()" :title-link-class="'tab-title-class'">
            <b-card-text ><AttachmentType/></b-card-text>
          </b-tab>
          <b-tab title="Attachment Requirement Settings" v-if="isAdmin()" :title-link-class="'tab-title-class'">
            <b-card-text><AttachmentRequirement/></b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import AttachmentType from "@/components/AttachmentType"
import AttachmentRequirement from "@/components/AttachmentRequirement"
import {roleService} from "@/mixins/roleService";


axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

export default {

  components: {
    AttachmentRequirement,
    AttachmentType
  },
  data: () => ({
  }),

  created () {
  },
  mixins: [
    roleService
  ],
}
</script>

<style lang="scss">
  .tab-title-class {  //overwrite default text color for accessibility purposes
    color: #2c3e50;
  }
</style>